//#region Libraries
import styled from "styled-components";
//#endregion

export const Paragraph = styled.p`
    font-size: 14px;
    margin: 0;
    margin-top: 5px;
    color: var(--light-gray-5);
    &.ellipsis {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
export const ReminderMessage = styled.div`
    background-color: var(--light-blue-2);
    border-radius: 8px;
    padding: 8px 16px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    span {
        font-size: 12px;
    }
`;
export const ImageNotifyErrorImage = styled.img`
    margin-top: 40px;
`;